var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "range-slider",
      class: { disabled: _vm.disabled },
      attrs: {
        "data-min": `${_vm._o_max}${_vm.icon}`,
        "data-max": `${_vm._o_min}${_vm.icon}`,
      },
    },
    [
      _c("span", { staticClass: "range-outer-rail" }),
      _vm._v(" "),
      _c(
        "drag-helper",
        {
          attrs: { disabled: _vm.disabled },
          on: {
            dragstart: _vm.dragStart,
            drag: _vm.drag,
            dragend: _vm.dragEnd,
          },
        },
        [
          _c(
            "span",
            {
              ref: "inner",
              staticClass: "range-slider-inner",
              style: {
                width: _vm.selectableLength + "%",
                left: _vm.selectableStartPoint + "%",
              },
            },
            [
              _c("input", {
                staticClass: "range-slider-hidden",
                attrs: { type: "text", name: _vm.name, disabled: _vm.disabled },
                domProps: { value: _vm.actualValue },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "range-slider-rail",
                style: { background: _vm.color },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "range-rec-rail",
                style: {
                  width: _vm.recommendedLength + "%",
                  left: _vm.recommendedStartPoint + "%",
                  background: _vm.recColor,
                },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "range-slider-fill",
                style: { width: _vm.knobLeft + "%" },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  ref: "knob",
                  staticClass: "range-slider-knob",
                  style: { left: _vm.knobLeft + "%" },
                  attrs: { "data-val": `${_vm.actualValue}${_vm.icon}` },
                },
                [_vm._t("knob")],
                2
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }